<template>
  <div class="caefa-header">
    <div id="top"></div>
    <div class="h20"></div>
    <el-row class="wp">
      <el-col :lg="16" :xs="24">
        <a href="http://www.caefa.org"
          ><img
            src="http://www.caefa.org/wp-content/themes/caefa/images/logo.jpg"
            alt=""
        /></a>
      </el-col>
      <el-col :lg="8" :xs="24" class="userinfo-box">
        <div style="text-align: right; width: 100%;">
          <div style="font-size: 16px;">欢迎进入中国民族民间工艺美术家协会会员系统</div>
          <div v-if="islogin">
            {{ association_title }} {{ user_name }}，您好 | <span @click="logout()">退出</span>
          </div>
          <div v-else><span v-if="$route.name !== 'pay'" @click="login()">登录</span></div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="登录" class="target-element">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-tabs v-model="activeName" type="border-card" stretch>
          <el-form-item label="会员类别" prop="user_type">
            <el-select
              v-model="form.user_type"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in optionsDict.membershipCategory"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="form.user_type == '个人会员' ? '手机号' : '法人手机号'" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-tab-pane label="密码登录" name="first">
            <el-form-item
              v-if="activeName == 'first'"
              label="密码"
              prop="password"
            >
              <el-input v-model="form.password" show-password></el-input>
            </el-form-item>
            <div style="text-align: right;">
              <el-button type="text" @click="foundPasswordClick">找回密码</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="second">
            <el-form-item
              v-if="activeName == 'second'"
              label="验证码"
              prop="code"
            >
              <el-input v-model="form.code">
                <el-button
                  slot="append"
                  :disabled="isDisabled"
                  @click="sendSmsCode()"
                  >{{ buttonText }}</el-button
                >
              </el-input>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="userLogin()">登 录</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import cookies from "@/libs/util.cookies";
import { request } from "@/api/service";

export default {
  data() {
    return {
      user_name: "用户",
      islogin: false,
      uuid: null,
      association_title: '',
      dialogVisible: false,
      // 倒计时秒数
      countdown: 0,
      // 按钮是否禁用
      isDisabled: false,
      // 按钮显示的文本
      buttonText: "发送验证码",
      optionsDict: {
        membershipCategory: [],
      },
      activeName: "first",
      form: {
        user_type: "个人会员",
        phone: "",
        password: "",
        key: "",
        code: "",
      },
      rules: {
        user_type: [
          {
            required: true,
            message: "请选择会员类别",
            trigger: "change",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的手机号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 25, message: "请输入正确的密码", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "请输入正确的验证码", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.refreshFun();
    
    let uuid = cookies.get("uuid");
    if(this.$route.path == '/login' && (!uuid || uuid.length === 0)) {
      this.dialogVisible = true;
      this.activeName = 'second'
      this.getDictFun();
    }
  },
  methods: {
    getDictFun() {
      var self = this;
      request({
        url: "/app/getDictionary",
        method: "post",
        data: {
          keys: [
            "membershipCategory", // 会员类型
          ],
        },
      }).then((res) => {
        self.optionsDict = res.data;
      });
    },
    refreshFun() {
      let uuid = cookies.get("uuid");
      if (uuid) {
        let name = cookies.get("name");
        let login_phone = cookies.get("login_phone");
        let association_title = cookies.get("association_title");
        if (login_phone) {
          this.user_name = login_phone;
        } else if (name) {
          this.user_name = name;
        } else {
          this.user_name = "用户";
        }
        this.islogin = true;
        this.association_title = association_title
      } else {
        this.islogin = false;
      }

      Vue.prototype.$self = this;
    },
    login() {
      this.dialogVisible = true;
      this.getDictFun();
    },
    sendSmsCode() {
      this.$refs.form.validateField("phone", (error) => {
        if (error) {
          return;
        } else {
          var self = this;
          request({
            url: "/app/sendCode",
            method: "post",
            data: {
              phone: this.form.phone,
            },
          }).then((res) => {
            if (res.code == 2000) {
              self.form.key = res.data.key;
              self.$message({
                message: "发送成功",
                type: "success",
              });
              self.setCodeBtnFun();
            } else {
              self.$message.error(res.msg);
            }
          });
        }
      });
    },
    setCodeBtnFun() {
      // 禁用按钮
      this.isDisabled = true;
      this.countdown = 60;
      this.buttonText = `${this.countdown} 秒后重试`;

      const timer = setInterval(() => {
        this.countdown--;
        this.buttonText = `${this.countdown} 秒后重试`;

        if (this.countdown <= 0) {
          // 清除定时器
          clearInterval(timer);
          // 启用按钮
          this.isDisabled = false;
          this.buttonText = "发送验证码";
        }
      }, 1000);
    },
    userLogin() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var self = this;
          request({
            url: "/app/phoneCodeLogin",
            method: "post",
            data: {
              user_type: this.form.user_type,
              login_phone: this.form.phone,
              sms_code: this.form.code,
              key: this.form.key,
              login_password: this.form.password,
            },
          }).then((res) => {
            if (res.code == 2000) {
              cookies.set("uuid", res.data.uuid);
              cookies.set("user_type", res.data.user_type);
              cookies.set("name", res.data.name ? res.data.name : "");
              cookies.set("association_title", res.data.association_title ? res.data.association_title : "");
              cookies.set("status", res.data.status ? res.data.status : 0);
              self.dialogVisible = false;
              window.location.reload();
            } else {
              self.$message.error(res.msg);
            }
          });
          console.log(this.form);
        }
      });
    },
    foundPasswordClick () {
      this.$confirm("本会员系统支持使用手机号码和短信验证码直接登录，您可以登录后自行修改登录密码。", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => { });
    },
    logout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        cookies.remove("uuid");
        cookies.remove("name");
        cookies.remove("login_phone");
        cookies.remove("user_type");
        this.islogin = false;
        window.location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.caefa-header {
  background-color: #fff;

  ::v-deep .target-element .el-dialog{
    width: 100%;
    min-height: 100vh !important;
    margin-top: 0 !important;
    box-sizing: border-box; 
  }

  @media (min-width: 768px) {
    ::v-deep .target-element .el-dialog {
      width: 30%;
      min-height: 0 !important;
      margin-top: 15vh !important;
    }
  }
}
#top {
  background: url(../assets/images/top_bg.jpg) left top repeat-x;
  height: 31px;
}
.h20 {
  height: 20px;
}
.wp {
  // min-width: 964px;
  margin: 0 auto;
  img {
    height: 6vh;
  }
  .userinfo-box {
    text-align: right;
    color: #b8741a;
    font-size: 18px;
    line-height: 45px;
  }
}

</style>
